
import { defineComponent, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import { Field, ErrorMessage } from "vee-validate";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep1 {
  q1_1: string;
  q1_2: string;
  q1_3: string;
}

export default defineComponent({
  name: "step-1",
  components: {
    Field,
    ErrorMessage,
    DropDownSection,
  },
  setup() {
    const store = useStore();

    const step1 = ref<IStep1>({
      q1_1: "",
      q1_2: "",
      q1_3: "",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    const listDropDownSections = [
         {title: "Research Study Definition", descriptions: [{description:
          " If you are conducting research on humans directly or indirectly (using human data or tissue),  " +
          " you must obtain IRB approval prior to starting your research. According to the federal regulations  " +
          " (45 CFR 46 102.f) a Human Subject means a living individual about whom an investigator conducting research obtains: " }, 
          {description:
          " 1. Data through intervention or interaction with individual" }, 
          {description:
          " 2. Identifiable private information." },
        ]},
         
    ]

    watchEffect(() => {
      const data = store.getters.currentSubject;
      if (data === null || data.data === undefined) return;
      step1.value.q1_1 = data.data.numSubRecruited;
      step1.value.q1_2 = data.data.researchSubject != undefined && data.data.researchSubject != null? data.data.researchSubject : "";
      step1.value.q1_3 = data.data.isIncludeGannonStudents == true? "1": "0";
    });

    return {
      submit,
      submitButtonRef,
      step1,
      listDropDownSections,
    };
  },
});
